var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.loading)?_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{staticClass:"text-center my-auto"},[_c('div',{staticClass:"text-center"},[_c('b-spinner',{key:"dark",attrs:{"type":"grow"}})],1)])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }